import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_TROUBLE_TICKETS_SICHTBARKEIT_ADMIN2 = '[BenutzerverwaltungModul] PostBenutzerTroubleTicketsSichtbarkeitAdmin2 laden';
export const POST_BENUTZER_TROUBLE_TICKETS_SICHTBARKEIT_ADMIN2_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerTroubleTicketsSichtbarkeitAdmin2 ausführen';
export const POST_BENUTZER_TROUBLE_TICKETS_SICHTBARKEIT_ADMIN2_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerTroubleTicketsSichtbarkeitAdmin2 laden erfolgreich';
export const POST_BENUTZER_TROUBLE_TICKETS_SICHTBARKEIT_ADMIN2_FEHLER = '[BenutzerverwaltungModul] PostBenutzerTroubleTicketsSichtbarkeitAdmin2 Ladefehler';
export const POST_BENUTZER_TROUBLE_TICKETS_SICHTBARKEIT_ADMIN2_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerTroubleTicketsSichtbarkeitAdmin2 nicht ausgeführt (evtl. Offline)';


export class PostBenutzerTroubleTicketsSichtbarkeitAdmin2Action implements Action {
    readonly type = POST_BENUTZER_TROUBLE_TICKETS_SICHTBARKEIT_ADMIN2;
        constructor(public benutzerSichtbarkeitRequest: api.BenutzerSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTroubleTicketsSichtbarkeitAdmin2AusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_TROUBLE_TICKETS_SICHTBARKEIT_ADMIN2_AUSFUEHREN;
        constructor(public benutzerSichtbarkeitRequest: api.BenutzerSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTroubleTicketsSichtbarkeitAdmin2ErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_TROUBLE_TICKETS_SICHTBARKEIT_ADMIN2_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerSichtbarkeitRequest: api.BenutzerSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTroubleTicketsSichtbarkeitAdmin2FehlerAction implements Action {
    readonly type = POST_BENUTZER_TROUBLE_TICKETS_SICHTBARKEIT_ADMIN2_FEHLER;
        constructor(public payload: any, public benutzerSichtbarkeitRequest: api.BenutzerSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTroubleTicketsSichtbarkeitAdmin2NichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_TROUBLE_TICKETS_SICHTBARKEIT_ADMIN2_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerTroubleTicketsSichtbarkeitAdmin2Actions =
    PostBenutzerTroubleTicketsSichtbarkeitAdmin2Action
    | PostBenutzerTroubleTicketsSichtbarkeitAdmin2AusfuehrenAction
    | PostBenutzerTroubleTicketsSichtbarkeitAdmin2ErfolgreichAction
    | PostBenutzerTroubleTicketsSichtbarkeitAdmin2FehlerAction
    | PostBenutzerTroubleTicketsSichtbarkeitAdmin2NichtAusgefuehrtAction
    ;
